<template>
  <div class="dashboard" >
    <v-container class="my-5">
      <v-layout wrap row justify-start class="mb-3">
        <v-flex xs12 md12 px-1>
          <v-text-field
            label="Search By Name, ID, Product..."
            solo
            v-model="searchText"
            @input="filterEmbeds()"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <div v-if="loading" class="text-xs-center">
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </div>
      <v-layout row wrap py-3>
        <v-flex xs12 sm12 md12>
            <span> {{ filteredEmbeds.length}} Results </span>
            <div class="text-xs-center">
              <v-pagination
                v-model="currentPage"
                :length="pagesNumber"
                :total-visible="5"
                @input="updateVisible"
              ></v-pagination>
            </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap py-3>
        <v-flex xs12 sm12 md12 v-for="form in visibleEmbeds" :key="form.id" mb-1>
          <v-card>
            <v-card-text>
              <v-layout row wrap align-center>
                <v-flex xs3>
                  <div style="font-size:11px;font-weight:600;">ID</div>
                  <div class="subheadline">{{ form.id }}</div>
                </v-flex>
                <v-flex xs3>
                  <div style="font-size:11px;font-weight:600;">NAME</div>
                  <div class="subheadline">{{ form.name }}</div>
                </v-flex>
                <v-flex xs3>
                  <div style="font-size:11px;font-weight:600;">PRODUCT</div>
                  <div class="subheadline">{{ form.product.name }}</div>
                </v-flex>
                <v-flex xs3 :style="`background:${form.ctaBack.hex};color:${form.dark?'#fff':'#000'};`" class="text-xs-center">
                  CTA BACK
                </v-flex>
                <v-flex xs3 :style="`background:${form.formBack.hex};color:${form.dark?'#fff':'#000'};`" class="text-xs-center">
                  FORM BACK
                </v-flex>
                <v-flex xs12 pt-2>
                  <v-text-field
                    label="Embed Code"
                    outline
                    readonly
                    hide-details
                    v-model="form.embed"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions dense>
              <v-spacer></v-spacer>
              <v-btn color="primary" dark small 
                v-clipboard:copy="form.embed"
                v-clipboard:success="clipboardSuccessHandler"
                v-clipboard:error="clipboardErrorHandler"
              >copy embed code</v-btn>
              <v-btn color="primary" dark small @click="duplicateForm(form.id)">duplicate</v-btn>
              <v-btn color="primary" dark small @click="goTo(`/form-builder/${form.id}`)">Edit</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap py-3>
        <v-flex xs12 sm12 md12>
          <div class="text-xs-center">
            <v-pagination
              v-model="currentPage"
              :length="pagesNumber"
              :total-visible="7"
              @input="updateVisible"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
      
    </v-container>
  </div>
</template>

<script>
import {firebase, db, auth, store} from '@/fb'
import { titleCase, randomString } from '@/customFunction'
import axios from 'axios';
export default {
  data() {
    return {
      searchText:'',
      loading:false,
      currentPage: 1,
      pageSize: 7,
      pagesNumber:0,
      embeds:[],
      filteredEmbeds:[],
      visibleEmbeds:[],
    }
  },
  props:{
    uid:{
      default:null
    }
  },
  methods:{
    goTo(path) {
      this.$router.push(path)
    },
		updateVisible() {
      this.sortByDate()
      this.visibleEmbeds = this.filteredEmbeds.slice((this.currentPage -1) * this.pageSize, ((this.currentPage -1) * this.pageSize) + this.pageSize);
      this.loading = false
    },
    sortByDate(){
      this.filteredEmbeds = this.filteredEmbeds
    },
    getPagesNumber(){
      if (this.filteredEmbeds.length % this.pageSize == 0) {
        this.pagesNumber = parseInt(this.filteredEmbeds.length / this.pageSize)
      } else {
        this.pagesNumber = parseInt(this.filteredEmbeds.length / this.pageSize) + 1
      }
		},
		filterEmbeds() {
      this.loading = true
			this.filteredEmbeds = this.embeds.filter(x=>{
        if(this.searchText){
          this.searchText = this.searchText.toLowerCase()
          if(x.name && x.name.toLowerCase().includes(this.searchText)) {
            return x
          } else
          if(x.id && x.id.toLowerCase().includes(this.searchText)) {
            return x
          } else
          if(x.product && x.product.name.toLowerCase().includes(this.searchText)) {
            return x
          }
          
        } else {
          return x
        }
      });
      this.getPagesNumber()
      this.currentPage = 1
			this.updateVisible()
		},
		clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    genToken() {
      this.loading = true
      let vtoken = `GS_DB_${randomString(8, 'aA#')}`
      this.token = vtoken
      this.loading = false
      return vtoken
    },
    async getForms(){
      this.loading = true
      let embeds = await store.collection("forms").get().then(x=>x.docs.map(y=>y.data()))
      console.log(embeds)
      if(embeds) {
        this.embeds = Object.values(embeds).map(x=>{
          return {
            ...x,
            embed: `<script gsid="${x.id}" gslanguage="AR" src="https://ashyaatform.web.app/masterembed.js">` + '<' + '/script>'
          }
        })
        this.filterEmbeds()
      }
    },
    async duplicateForm(id){
      let a = await store.collection("forms").doc(id).get().then(x=>x.data())
      a.id = this.genToken()
      await store.collection("forms").doc(`${a.id}`).set(a);
      this.goTo(`/form-builder/${a.id}`)
    }
  },
  watch:{
    
  },
  created(){
    this.getForms()
  }
}
</script>

<style>

</style>
